import React  from 'react';
const value = {
  path:"default_insurance",
  title:"Mortgage Default Insurance",
  date_modified:"Dec 2019",
  date_created:"Dec 2019",
  content:
[
<p align="justify">
  Mortgage default insurance protects the <b>lender</b> of a mortgage, should the borrower default on their loan. The borrower buys it for the benefit of the lender. In Canada, home buyers with a down-payment of less than 20% are required to buy default insurance; high ratio borrowers are considered risky investments and so require additional precautions. So, to be clear, default insurance does not protect the borrower or cover their mortgage payments should the need arise. If the borrower defaults, the insurer sells the property and pays off the debt to the lender. If the sale of the property does not cover all expenses, the insurer will compensate the lender for anything they are owed. At this point, the borrower becomes responsible for the shortfall and the mortgage insurer can pursue them to recoup what is owed.
</p>
  ,
<p align="justify">
  Default insurance can be purchased from one of three bodies: the Canadian Mortgage and Housing Commission, which is state-owned, Genworth, or Canada Guaranty which are both private insurers. Typically, default insurance costs between 2.8% and 4.0% of your mortgage principal; but other factors such as the value of the house, the amortization period, and what the property is going to be used for (e.g. rental investment) also affect the premium. While the premium is normally rolled into the mortgage - so you don’t have to pay it up front - in Ontario, Manitoba, and Quebec the provincial tax on the insurance is due at close. For example: if you were to take out a mortgage of $250,000, the default insurance premium would be approximately $7,500, and with a provincial sales tax of 8%, $600 would be due before you could take ownership of the house.You can choose to pay the entire premium up front, though; in that case, you would avoid the incurred interest payments.
</p>
,
<p align="justify">
It is important not to confuse mortgage default insurance (what we have been discussing here) with mortgage protection insurance, usually sold by a bank. In general, you want to avoid purchasing mortgage protection insurance. While mortgage default insurance protects your mortgage lender should you default on your payments, mortgage protection insurance is more akin to a life insurance policy - an expensive, less useful, life insurance policy. The idea of mortgage protection is: in the event of your death or injury, the insurance policy will cover the cost of your mortgage payments - so your family is not stuck with obligations they cannot meet. However, these protection policies probably aren’t the most efficient way to acquire this peace-of-mind. The reasons one might avoid mortgage protection insurance in favour of a general life insurance policy are:
</p>
,
<ul>
  <li> The payout is made to your lender, not your family.
    <ul>
      <li>This means your family has no control over how the money is spent.</li>
      <li>In comparison, a normal life insurance policy would payout a lump-sum to your family. In this situation, your family has the option of keeping up with payments, paying off the mortgage at once, or using it for another, more urgent, need.</li>
    </ul>
  </li>
  <li> The payout will shrink as your mortgage shrinks.
    <ul>
      <li>The payout from a mortgage protection policy only covers what’s left on your mortgage; so as time passes, your premium stays the same, but your payout decreases. </li>
      <li>Alternatively, the payout from typical life insurance remains the same throughout the duration of the policy.</li>
    </ul>
  </li>
  <li> Generally, mortgage protection policies are underwritten after the fact.
    <ul>
      <li>This means the insurance provider will only confirm that you are eligible for coverage after a claim has been made, and after you have already been making premium payments for months, or even years.</li>
      <li>If the insurance company finds a technicality that voids your contract, your family would be left in a very tough spot.</li>
    </ul>
  </li>
  <li> Mortgage protection insurance is expensive.
    <ul>
      <li>General life insurance policies are a cheaper option.</li>
    </ul>
  </li>
</ul>
],
  tags:["mortgage","insurance"]
}

export default value



// WEBPACK FOOTER //
// src/content/defaultInsurance.js